/*
 * The one country a typed or autofilled text names exactly: by its name in the
 * app's language, its English name, or its ISO code. A browser autofills the
 * country in English ("Denmark") into a Danish list, and nothing used to turn
 * that text into a choice — the field showed "Denmark" with no flag, and the
 * save failed on a country nobody had picked.
 */

// Case, accents and surrounding spaces do not count: "  côte d'ivoire" names Côte d'Ivoire.
export const fold = (s) => String(s ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase()

export const exactCountry = (list, text) => {
    const wanted = fold(text)
    if (!wanted) return null
    return (list || []).find(c => !c.header && c.id && (fold(c.name) === wanted || fold(c.nameEn) === wanted || fold(c.id) === wanted)) ?? null
}

export default exactCountry
